<template>
    <div>
        <div class="wrapper">
            <div class="header" v-if="header">
                <span @click="getPages">
                    <welcome-refresh-button class="header__refresh">Обновить</welcome-refresh-button>
                </span>

                <welcome-pages-category class="header__category" />

                <div class="header__link-wrapper">
                    <a class="link header__link" href="/page">
                        <span>{{ $lang('welcome.pages.item.project.link') }}</span>
                    </a>
                </div>
            </div>

            <a class="category" :href="'/archive/' + page.historical_status_id">
                {{ $lang(getStatus(page.historical_status_id)) }}
            </a>

            <img class="image" v-if="page.main_image" :src="page.main_image.url" :alt="page.name"/>

            <div class="content">
                <p class="name" v-html="formatName(page.name)"></p>

                <div class="dates" v-if="page.birthday_at && page.died_at">{{ formatDate(page) }}</div>

                <p class="epitaph">{{ page.epitaph }}</p>
            </div>

            <div class="separator"></div>

            <a class="link footer__link" :href="page.link">
                <span>{{ $lang('welcome.pages.item.page.link') }}</span>
            </a>
        </div>
    </div>
</template>

<script>

import WelcomeRefreshButton from "./WelcomeRefreshButton.vue";
import WelcomePagesCategory from "./WelcomePagesCategory.vue";
import {mapActions} from "vuex";
const HISTORY_STATUS = window.laravel.historyStatus;
export default {
    name: 'WelcomePagesItem',
    components: {WelcomePagesCategory, WelcomeRefreshButton},
    props: {
        page: {
            type: Object,
            required: true,
        },
        header: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        ...mapActions('welcome', [
            'getPages',
        ]),
        formatName(name) {
            let formatted = '';
            name = name.split(' ');
            name.forEach((item, index) => formatted += index === 0 ? item + '<br>' : item + ' ');
            return formatted.trim();
        },
        formatDate(page) {
            let birthday_at = new Date(page.birthday_at.replace(" ", "T") + "Z").getFullYear();
            let died_at = new Date(page.died_at.replace(" ", "T") + "Z").getFullYear();
            return birthday_at + ' — ' + died_at;
        },
        getStatus(id) {
            let status = '';

            switch (id) {
                case HISTORY_STATUS.famous:
                    status = 'status.famous';
                    break;
                case HISTORY_STATUS.military:
                    status = 'status.military';
                    break;
                case HISTORY_STATUS.interesting:
                    status = 'status.interesting';
                    break;
            }

            return status;
        },
        onClickStatus(statusId) {
            console.log(this.$router.resolve('archive', ).href);
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
.wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    @media (max-width: 1159px) {
    }
}
.header {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    display: none;
    @media (max-width: 1159px) {
        display: flex;
    }
    @media (max-width: 600px) {
        justify-content: flex-start;
    }
    @media (max-width: 560px) {
        flex-direction: column;
        align-items: flex-start;
    }
}
.header__category {
    margin-left: 1rem;
    @media (max-width: 560px) {
        margin-left: 0;
        margin-top: 1rem;
    }
}
.header__link-wrapper {
    flex: 1 1;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 600px) {
        display: none;
    }
}
.header__link {

}
.category {
    display: flex;
    padding: 0.7rem 1.5rem;
    align-items: flex-start;
    border-radius: 50px;
    border: 1px solid #00B4FF;
    font-family: $font-family-secondary;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 130%; /* 18.2px */
    letter-spacing: -0.25px;
    color: #00B4FF;
    background: #fff;
    @media (max-width: 1159px) {
       display: none;
    }
}
.image {
    margin-top: 2.6rem;
    border-radius: 5px;
    width: 100%;
    height: 32.5rem;
    object-fit: cover;
    object-position: center;
    @media (max-width: 1159px) {
        margin-top: 2rem;
        width: 16.7rem;
        height: 16.7rem;
        border-radius: 1000px;
    }
}
.content {
    margin-top: 2.6rem;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 1 1;
    @media (max-width: 1159px) {
        margin-top: 2rem;
    }
}
.name {
    font-family: $font-family-secondary;
    font-size: 2.2rem;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -1.25px;
    text-transform: uppercase;
    @media (max-width: 1159px) {
        font-size: 2.6rem;
    }
}
.dates {
    margin-top: 1rem;
    font-family: $font-family-secondary;
    font-size: 4rem;
    font-weight: 600;
    line-height: 130%; /* 52px */
    letter-spacing: -1.25px;
    text-transform: uppercase;
    color: #292929;
    white-space: break-spaces;
}
.epitaph {
    margin-top: 1rem;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 140%;
    color: #4E4E4E;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    -moz-line-clamp: 6;
    @media (max-width: 1159px) {
        line-height: 120%;
    }
}
.separator {
    margin-top: 2.6rem;
    width: 100%;
    height: 0.1rem;
    background: #C0C9DA;
    @media (max-width: 1159px) {
        margin-top: 2rem;
    }
}
.footer__link {
    margin-top: 2.6rem;
    @media (max-width: 1159px) {
        margin-top: 2rem;
    }
}
</style>
